export function resolveSelectedPlan<T extends { id: string }>(
  plans: readonly T[] | undefined,
  selectedPlanId: string | undefined,
): T | undefined {
  if (!plans?.length) return undefined;
  if (selectedPlanId) {
    const selected = plans.find((plan) => plan.id === selectedPlanId);
    if (selected) return selected;
  }
  return plans[0];
}

export function hasLocalUnsavedDraft<T extends { id: string }>(
  localPlans: readonly T[] | undefined,
  serverPlans: readonly T[] | undefined,
): boolean {
  return (localPlans ?? []).some(
    (localPlan) =>
      localPlan.id.length <= 2 &&
      !(serverPlans ?? []).some((serverPlan) => serverPlan.id === localPlan.id),
  );
}
